<template>
    <div class="shared-lazy-img">
        <component v-if="inViewport" :is="$slots.default ? 'picture' : 'div'" class="shared-lazy-img__image-wrapper">
            <slot></slot>
            <img
                :alt="$props.alt"
                :src="$props.src"
                :srcset="$props.srcset"
                :sizes="$props.sizes"
                :class="imageClassObj"
                class="shared-lazy-img__image"
                @load="onImageLoad()"
                @error="onImageError()" width="185"
                                height="278"
            />
        </component>
        <spinner-gant v-if="isGant()" :class="spinnerClassObj" class="shared-lazy-img__spinner" />
        <spinner-vermont v-else :class="spinnerClassObj" class="shared-lazy-img__spinner" />
    </div>
</template>

<script>
import { isGant } from '../../utilities/general';

const TRIGGER_MARGIN = '30px 0px';
const TRIGGER_THRESHOLD = 0.01; // Fraction of the image that needs to be visible in (viewport + TRIGGER_MAGIN) to trigger image loading

export default {
    data() {
        return {
            inViewport: false,
            loaded: false,
            error: false,
            observer: null,
        };
    },
    props: {
        alt: {
            type: String,
            required: true,
        },
        sizes: String,
        src: {
            type: String,
            required: true,
        },
        srcset: String,
    },
    mounted() {
        this.observer = new IntersectionObserver(this.onIntersection, {
            rootMargin: TRIGGER_MARGIN,
            threshold: TRIGGER_THRESHOLD,
        });
        this.observer.observe(this.$el);
    },
    beforeDestroy() {
        this.observer.disconnect();
    },
    computed: {
        imageClassObj() {
            return {
                'shared-lazy-img__image_loaded': this.loaded || this.error,
            };
        },
        spinnerClassObj() {
            return {
                'shared-lazy-img__spinner_hidden': this.loaded || this.error,
            };
        },
    },
    methods: {
        isGant,
        onImageLoad() {
            this.loaded = true;
        },
        onImageError() {
            this.error = true;
        },
        onIntersection([{ isIntersecting }]) {
            if (isIntersecting) {
                this.inViewport = true;
                this.observer.disconnect();
            }
        },
    },
};
</script>
